import { HttpClient } from '@angular/common/http';
import { provideTransloco, Translation, TranslocoLoader, TranslocoModule } from '@jsverse/transloco';
import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }
}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        // provideTransloco also registers the default transpiler, missing
        // handler, interceptor and fallback strategy - in @jsverse/transloco 8
        // these are no longer built-in defaults, so providing only
        // TRANSLOCO_CONFIG/TRANSLOCO_LOADER (the old @ngneat v6 setup) makes
        // TranslocoService fail to instantiate (NG0201 -> phantom NG0200).
        provideTransloco({
            config: {
                availableLangs: ['en'],
                defaultLang: 'en',
                prodMode: environment.production
            },
            loader: TranslocoHttpLoader
        })
    ]
})
export class TranslocoRootModule {}
